const showLogs = process.env.NODE_ENV !== "production";

class BaseTrigger {
  static types = {};

  constructor(type, options = {}) {
    this.type = type;
    this.options = options;

    if (!BaseTrigger.types[type]) {
      showLogs &&
        console.error(`[Trigger] Trigger type "${type}" is not registered`);

      return;
    }
  }

  static registerType(key, handlerAttacher) {
    if (typeof key !== "string" || !key.trim()) {
      showLogs && console.error("[Trigger] Invalid trigger type key");

      return false;
    }

    if (typeof handlerAttacher !== "function") {
      showLogs &&
        console.error("[Trigger] Handler attacher must be a function");

      return false;
    }

    if (BaseTrigger.types[key]) {
      showLogs &&
        console.warn(
          `[Trigger] Trigger type "${key}" is already registered. Overwriting.`
        );
    }

    BaseTrigger.types[key] = handlerAttacher;
    showLogs && console.log(`[Trigger] Trigger type "${key}" registered`);

    return true;
  }

  attach(callback) {
    if (!BaseTrigger.types[this.type]) {
      showLogs &&
        console.error(`[Trigger] Trigger type "${this.type}" not found`);

      return false;
    }

    const result = BaseTrigger.types[this.type](this.options, callback);
    showLogs && console.log(`[Trigger] Trigger type "${this.type}" attached`);

    return result;
  }
}

export default BaseTrigger;
